import * as React from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * @typedef {React.HTMLAttributes<HTMLDivElement>} CardProps
 */

/**
 * Renders a basic card component with default styling.
 * Forwards all native div attributes.
 * @param {CardProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 */
function CardComponent({ className, ...props }, ref) {
  const defaultClasses = 'flex flex-row p-2 gap-2 border border-gray-200 rounded-lg p-4';

  return <div ref={ref} className={twMerge(defaultClasses, className)} {...props} />;
}

const Card = React.forwardRef(CardComponent);

Card.displayName = 'Card';

export { Card };
